import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import './AuthStep.css';

interface CompanySettings {
    legal_name?: string;
    trade_name?: string;
    logo?: string | null;
}

const AuthStep = () => {
    const [phone, setPhone] = useState('');
    const [companySettings, setCompanySettings] = useState<CompanySettings>({});
    const navigate = useNavigate();

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const res = await axios.get(`${API_BASE_URL}/api/public/company/`);
                setCompanySettings(res.data);
            } catch (err) {
                console.error('Error fetching company settings:', err);
            }
        };
        fetchSettings();
    }, []);

    const formatPhone = (value: string): string => {
        const numbers = value.replace(/\D/g, '');
        if (numbers.length <= 10) {
            return numbers.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3').replace(/-$/, '');
        }
        return numbers.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3').replace(/-$/, '');
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const digitsOnly = phone.replace(/\D/g, '');
        if (digitsOnly.length >= 10 && digitsOnly.length <= 11) {
            navigate(`?phone=${encodeURIComponent(digitsOnly)}`);
        }
    };

    const displayName = companySettings.legal_name || companySettings.trade_name || 'Y-Agenda';

    return (
        <div className="auth-step-page">
            <div className="auth-step-container">
                <div className="auth-step-image-panel">
                    <img 
                        src="/agendainicioGold.png" 
                        alt="Y-Agenda" 
                        className="auth-step-hero-image" 
                    />
                </div>
                <div className="auth-step-form-panel">
                    <div className="auth-step-form-wrapper">
                        <div className="auth-step-brand-header">
                            {companySettings.logo && (
                                <img 
                                    src={companySettings.logo} 
                                    alt="Logo" 
                                    style={{ maxHeight: '60px', objectFit: 'contain', marginBottom: '0.5rem' }}
                                />
                            )}
                            <h1 className="auth-step-brand-title">
                                {displayName}
                            </h1>
                            <p className="auth-step-brand-subtitle">
                                Gestão inteligente de agendamentos
                            </p>
                        </div>
                        <div className="auth-step-form-header">
                            <h2>Identifique-se</h2>
                            <p>Digite seu telefone para agendar</p>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="mb-4">
                                <label className="form-label">Seu Telefone / WhatsApp</label>
                                <input
                                    type="text"
                                    value={formatPhone(phone)}
                                    onChange={(e) => setPhone(e.target.value)}
                                    placeholder="(99) 99999-9999"
                                    required
                                    maxLength={15}
                                    className="form-control"
                                />
                                <small style={{ color: 'var(--text-muted)', textAlign: 'center', display: 'block', marginTop: '0.5rem' }}>
                                    Digite seu telefone com DDD (10 ou 11 dígitos)
                                </small>
                            </div>
                            <button type="submit" className="btn btn-primary w-100">
                                Continuar
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AuthStep;
